import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import RangesTable from "./RangesTable";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  table: {
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const AllRanges = ({ isAdmin }) => {
  const classes = useStyles();

  const [dataObj, setDataObj] = useState({
    ranges: [],
    onboardingStatuses: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/Ranges/")
      .then((response) => response.json())
      .then((data) =>
        setDataObj({
          ranges: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <RangesTable data={dataObj} isAdmin={isAdmin} />
        </div>
      )}
    </>
  );
};
export default AllRanges;
